import React, { useState, useEffect } from 'react'
// import homeDeal from 'assets/logos/bbd.png'
import AwesomeSlider from 'react-awesome-slider'
import CoreStyles from 'react-awesome-slider/src/core/styles.scss'
import { isFeatureEnabled } from 'utils/uiHelper'
import './style.scss'
import withAutoplay from 'react-awesome-slider/dist/autoplay'
const AutoplaySlider = withAutoplay(AwesomeSlider)
const CarousalOffer = props => {
    const [getOfferList, setOfferList] = useState(props.banners)
    const { crousalHeader = {} } = isFeatureEnabled()
    const [isLoading, setIsLoading] = useState(true)
    
    const handleLoad = () => {
        setIsLoading(false)
    }
    useEffect(() => {
        // const color = window.getComputedStyle(document.documentElement).getPropertyValue('--arrow-value');
        // console.log(`--color-logo: ${color}`);
        let custom = 2
        if (getOfferList.length > 0) {
            custom = getOfferList.length
        }
        document.documentElement.style.setProperty('--arrow-value', `${(153-((custom-1)*11+17))/2}px`)
    }, [])

    return (
        <>
            {getOfferList && getOfferList.length > 0 && (
                <>
                    <div className="bc-neutral-100 mt-4 br-8 o-hidden carousalImg">
                        <AutoplaySlider
                            cssModule={CoreStyles}
                            bullets={getOfferList.length > 1 ? true : false}
                            timer={false}
                            interval={3000}
                            play={true}
                            buttonContentLeft={
                                getOfferList.length > 1 ? (
                                    <svg
                                        width="6"
                                        height="10"
                                        viewBox="0 0 6 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M5 9L1 5L5 1"
                                            stroke="white"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                ) : (
                                    ''
                                )
                            }
                            buttonContentRight={
                                getOfferList.length > 1 ? (
                                    <svg
                                        width="6"
                                        height="10"
                                        viewBox="0 0 6 10"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1 9L5 5L1 1"
                                            stroke="white"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                ) : (
                                    ''
                                )
                            }
                            organicArrows={false}
                        >
                            {getOfferList.map(item => (
                                <div className="br-4">
                                    <div style={{ display: isLoading ? "block" : "none" }} >
                                        <img src={'https://fastui.cltpstatic.com/image/upload/w_176,c_scale,q_1,f_auto,q_auto/resources/images/loader.png'} alt={'img'} width={450} height={205} />
                                    </div>
                                    <div style={{ display: isLoading ? "none" : "block" }}>
                                        <a href={item.url} target="_blank">
                                        <img src={item.src} onLoad={handleLoad} alt={'img'} width={260} height={205} />
                                        </a>
                                    </div>        
                                </div>
                            ))}
                        </AutoplaySlider>
                    </div>
                </>
            )}
        </>
    )
}

export default CarousalOffer
